import React from "react";
import "./About.css";
import SEO from "../../Components/SEO/SEO";

const About = () => {
  return (
    <div className="about-page fade-in">
      <SEO
        title="О нас - Шахризада"
        description="Узнайте больше о нашем заведении, нашей истории и команде."
        keywords="о нас, Шахризада, история, команда, ресторан"
      />
      <div className="about-container">
        <h1>О Нашем Заведении</h1>
        <p>
          «Шахризада» — это не просто кафе, а настоящий оазис восточной культуры
          и гостеприимства. Мы приглашаем вас в кулинарное путешествие, где
          вековые традиции встречаются с современным взглядом на кухню. Каждое
          блюдо в нашем меню — это история, рассказанная через яркие вкусы и
          пряные ароматы, приготовленная с любовью из отборных продуктов. Наша
          миссия — дарить вам не просто еду, а незабываемые впечатления и
          частичку тепла сказочного Востока.
        </p>

        <div className="working-hours">
          <h2>Режим Работы</h2>
          <ul>
            <li>
              Понедельник - Суббота: <strong>9:00 - 21:00</strong>
            </li>
            <li>
              Воскресенье: <strong>12:00 - 21:00</strong>
            </li>
          </ul>
        </div>

        <div className="contact-info">
          <h2>Наши Контакты</h2>
          <p>Телефон: +7 (924) 870-51-07</p>
          <p>Адрес: г. Олёкминск, ул. Партизанская, д. 1</p>
        </div>
      </div>
    </div>
  );
};

export default About;
